import { render, staticRenderFns } from "./AddForm.vue?vue&type=template&id=9364de2e&scoped=true"
import script from "./AddForm.vue?vue&type=script&lang=js"
export * from "./AddForm.vue?vue&type=script&lang=js"
import style0 from "./AddForm.vue?vue&type=style&index=0&id=9364de2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9364de2e",
  null
  
)

export default component.exports